import api from '../services/api';
import apiWithJwt from '../services/apiWithJwt';
import { types } from '../store/constants/types';

export const emptyReduxUser = () => {
  return dispatch => {

    dispatch({type : types.GET_LOGIN_FAILED, payload : []})

    dispatch({type : types.GET_SIGNUP_FAILED, payload : []})

    dispatch({type : types.CHECK_AUTH_FAILED, payload : []})

    dispatch({type : types.GET_ACCOUNT_PROFILE_FAILED, payload : []})

    dispatch({type : types.UPDATE_ACCOUNT_PROFILE_FAILED, payload : []})

    dispatch({type : types.GET_ALL_CUSTOMER_FAILED, payload : []})

    dispatch({type : types.CREATE_CUSTOMER_FAILED, payload : []})

    dispatch({type : types.UPDATE_CUSTOMER_FAILED, payload : []})
    
    dispatch({type : types.GET_PROFILE_WITH_USER_FAILED, payload : []})
    
    dispatch({type : types.DELETE_CUSTOMER_FAILED, payload : []})
    
    dispatch({type : types.CHANGE_PASSWORD_FAILED, payload : []})
  }
}

export const logIn = (data) => {
  return (dispatch) => {
    const apiWithToken = apiWithJwt(localStorage.token);
    apiWithToken.post('/user/login',data)
      .then((response) => {
        console.log("response in login", response);
        dispatch({ type: types.GET_LOGIN_SUCCESS, payload: response.data });
      })
      .catch(error => {
        console.log("error in login", error);
        dispatch({ type: types.GET_LOGIN_FAILED, payload: (error.response.data)});
      });
  };
};

export const userSignup = (data) => {
  return (dispatch) => {
    const apiWithToken = apiWithJwt(localStorage.token);
    apiWithToken.post('/user/signup',data)
      .then((response) => {
        console.log("response in signup", response);
        dispatch({ type: types.GET_SIGNUP_SUCCESS, payload: response.data });
      })
      .catch(error => {
        console.log("error in signup", error);
        dispatch({ type: types.GET_SIGNUP_FAILED, payload: (error.response.data)});
      });
  };
};

export const resetLogIn = () => {
  return dispatch => {
     dispatch({type : types.GET_LOGIN_SUCCESS,payload : []})
}};

export const checkAuth = () => {
  return (dispatch) => {
    const apiWithToken = apiWithJwt(localStorage.token);
    apiWithToken.get('/user/check/auth')
      .then((response) => {
        console.log("response in login", response);
        dispatch({ type: types.CHECK_AUTH_SUCCESS, payload: response.data });
      })
      .catch((error) => {
        console.log("error in login", error);
        dispatch({ type: types.CHECK_AUTH_FAILED, payload: (error.response.data)});
      });
  };
};

export const resetCheckAuth = () => {
  return dispatch => {
     dispatch({type : types.CHECK_AUTH_SUCCESS, payload : []})
}};

export const getAccountProfile = () => {
  console.log(localStorage.token);
  return (dispatch) => {
    const apiWithToken = apiWithJwt(localStorage.token);
    apiWithToken.get('/user/account/profile')
      .then((response) => {
        dispatch({ type: types.GET_ACCOUNT_PROFILE_SUCCESS, payload: response.data });
      })
      .catch((error) => {
        dispatch({ type: types.GET_ACCOUNT_PROFILE_FAILED, payload: (error.response.data)});
      });
  };
};

export const updateAccountProfile = (data) => {
  return (dispatch) => {
    const apiWithToken = apiWithJwt(localStorage.token);
    apiWithToken.put('/user/account/profile/edit', data)
      .then((response) => {
        dispatch({ type: types.UPDATE_ACCOUNT_PROFILE_SUCCESS, payload: response.data });
      })
      .catch((error) => {
        dispatch({ type: types.UPDATE_ACCOUNT_PROFILE_FAILED, payload: (error.response.data)});
      });
  };
};

export const getAllCustomers = (perPage = 10, currentPage = 1) => {

  let queryParams = `?perPage=${perPage}&currentPage=${currentPage}`;

  return (dispatch) => {
    const apiWithToken = apiWithJwt(localStorage.token);
    apiWithToken.get('/user/profiles'+queryParams)
      .then((response) => {
        dispatch({ type: types.GET_ALL_CUSTOMER_SUCCESS, payload: response.data });
      })
      .catch((error) => {
        dispatch({ type: types.GET_ALL_CUSTOMER_FAILED, payload: (error.response.data)});
      });
  };
};

export const resetGetAllCustomers = () => {
  return dispatch => {
    dispatch({type : types.GET_ALL_CUSTOMER_SUCCESS, payload : []})
}};

export const createCustomer = (data) => {
  return (dispatch) => {
    const apiWithToken = apiWithJwt(localStorage.token);
    apiWithToken.post('/user/create/profile', data)
      .then((response) => {
        dispatch({ type: types.CREATE_CUSTOMER_SUCCESS, payload: response.data });
      })
      .catch((error) => {
        dispatch({ type: types.CREATE_CUSTOMER_FAILED, payload: (error.response.data)});
      });
  };
};

export const resetCreateCustomer = () => {
  return dispatch => {
     dispatch({type : types.CREATE_CUSTOMER_SUCCESS, payload : []})
}};

// export const updateCustomer = (userId, data) => {
//   return (dispatch) => {
//     const apiWithToken = apiWithJwt(localStorage.token);
//     apiWithToken.put(`/user/update/profile/${userId}`, data)
//       .then((response) => {
//         dispatch({ type: types.UPDATE_CUSTOMER_SUCCESS, payload: response.data });
//       })
//       .catch((error) => {
//         dispatch({ type: types.UPDATE_CUSTOMER_FAILED, payload: error.response?.data || { message: 'Something went wrong.' } });
//       });
//   };
// };
// export const updateCustomer = (userId, data) => async (dispatch) => {
//   const apiWithToken = apiWithJwt(localStorage.token);
//   dispatch({ type: types.UPDATE_CUSTOMER_REQUEST }); // optional
//   try {
//     const response = await apiWithToken.put(`/user/update/profile/${userId}`, data);
//     dispatch({ type: types.UPDATE_CUSTOMER_SUCCESS, payload: response.data });
//   } catch (error) {
//     dispatch({ 
//       type: types.UPDATE_CUSTOMER_FAILED, 
//       payload: error.response?.data || { message: 'Something went wrong.' } 
//     });
//   }
// };

export const updateCustomer = (userId, data) => {
  return (dispatch) => {
    const api = apiWithJwt(localStorage.token);
    api.put(`/user/update/profile/${userId}`, data)
      .then((response) => {
        dispatch({ type: types.UPDATE_CUSTOMER_SUCCESS, payload: response.data });
      })
      .catch((error) => {
        dispatch({
          type: types.UPDATE_CUSTOMER_FAILED,
          payload: error.response?.data || { status: "error", message: "Something went wrong." }
        });
      });
  };
};

export const resetUpdateCustomer = () => {
  return dispatch => {
    dispatch({ type: types.UPDATE_CUSTOMER_SUCCESS, payload: [] });
  };
};

export const getProfileWithUser = (userId) => {
  return (dispatch) => {
    const apiWithToken = apiWithJwt(localStorage.token);
    apiWithToken.get(`/user/profilewithuser/${userId}`)
      .then((response) => {
        dispatch({ type: types.GET_PROFILE_WITH_USER_SUCCESS, payload: response.data });
      })
      .catch((error) => {
        //dispatch({ type: types.GET_PROFILE_WITH_USER_FAILED, payload: (error.response.data)});
        if (error.response?.status === 404) {
          dispatch({ type: types.GET_PROFILE_WITH_USER_NOT_FOUND });
        } else {
          dispatch({
            type: types.GET_PROFILE_WITH_USER_FAILED,
            payload: error.response?.data || { status: "error", message: "Something went wrong." }
          });
        }
      });
  };
};

export const deleteUserById = (userId) => {
  return (dispatch) => {
    const apiWithToken = apiWithJwt(localStorage.token);
    apiWithToken.delete(`/user/deleteuser/${userId}`)
      .then((response) => {
        dispatch({ type: types.DELETE_CUSTOMER_SUCCESS, payload: response.data });
      })
      .catch((error) => {
        dispatch({ type: types.DELETE_CUSTOMER_FAILED, payload: (error.response.data)});
      });
  };
};

export const changePassword = (data) => {
  return (dispatch) => {
    const apiWithToken = apiWithJwt(localStorage.token);
    apiWithToken.post('/user/account/password/edit', data)
      .then((response) => {
        dispatch({ type: types.CHANGE_PASSWORD_SUCCESS, payload: response.data });
      })
      .catch((error) => {
        dispatch({ type: types.CHANGE_PASSWORD_FAILED, payload: (error.response.data) });
      });
  };
};